import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.newAccount || initialState;

export const selectNewAccount = createSelector([selectSlice], state => state);
